import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import "../styles.css";

const Clinics = () => {
  const [clinics, setClinics] = useState([]);

  useEffect(() => {
    // Professional demo data
    const demoClinics = [
      { id: 1, name: "Sunrise Medical Centre", region: "North District", patients: 120 },
      { id: 2, name: "Greenfield Family Clinic", region: "South District", patients: 90 },
      { id: 3, name: "Maple Health Institute", region: "East District", patients: 75 },
      { id: 4, name: "Riverbend Primary Care", region: "West District", patients: 140 },
      { id: 5, name: "Hillside Community Clinic", region: "Central District", patients: 110 },
      { id: 6, name: "Lakeside Wellness Centre", region: "North District", patients: 65 },
      { id: 7, name: "Oakridge Health Services", region: "South District", patients: 98 },
      { id: 8, name: "Silverline Medical Hub", region: "East District", patients: 130 },
      { id: 9, name: "Unity Care Clinic", region: "Central District", patients: 155 },
      { id: 10, name: "Cedar Grove Health Centre", region: "West District", patients: 88 },
    ];

    setClinics(demoClinics);
  }, []);

  return (
    <div>
      <Navbar />
      <div className="page-container">
        <h1 className="page-title">Clinic Directory</h1>
        <p className="page-subtitle">
          Registered healthcare facilities and patient distribution overview
        </p>

        <div className="page-card">
          {clinics.length === 0 ? (
            <p className="empty-state">No clinics found.</p>
          ) : (
            <table className="clinics-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Clinic Name</th>
                  <th>Region</th>
                  <th>Total Patients</th>
                </tr>
              </thead>
              <tbody>
                {clinics.map((c, index) => (
                  <tr key={c.id}>
                    <td>{index + 1}</td>
                    <td>{c.name}</td>
                    <td>{c.region}</td>
                    <td>{c.patients}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Clinics;